import {ILookupEntry} from 'shared/types/lookups';
import {IReportTableColumn} from 'store/slices/report-configuration-slice/dd-lookups';

export interface IFindTableReportConditionByOperatorCodeArgs {
    operatorCode: string | undefined;
    filterLookups: ILookupEntry[] | undefined;
}
export const findTableReportConditionByOperatorCode = ({
    filterLookups,
    operatorCode,
}: IFindTableReportConditionByOperatorCodeArgs) => {
    if (!filterLookups || !operatorCode) return undefined;
    return filterLookups.find(lookup => lookup.lookupCode === operatorCode);
};

export interface IGetValueFieldTypeBySelectedFieldArgs {
    fieldName: string | undefined;
    reportColumns: IReportTableColumn[] | undefined;
}
export const findReportColumnByFieldName = ({
    fieldName,
    reportColumns,
}: IGetValueFieldTypeBySelectedFieldArgs) => {
    if (!fieldName || !reportColumns) return undefined;
    return reportColumns.find(col => col.name === fieldName);
};
